import store from "~/store/index.js"
import components from "~/components/index.js"
import "~/assets/css/index.css"

import {GetDictConfig, GetDictConfigByKey} from "~/functions/common"
export const getDictConfig = GetDictConfig
export const getDictConfigByKey = GetDictConfigByKey

// 普通字典方法相关
import {
  GetLabelByCode,
  GetLabelByCodes,
  GetCodeByLabel,
  GetCodeByLabels,
  GetDictObjByDictTypes
} from "~/functions/dict"
export const getLabelByCode = GetLabelByCode
export const getLabelByCodes = GetLabelByCodes
export const getCodeByLabel = GetCodeByLabel
export const getCodeByLabels = GetCodeByLabels
export const getDictObjByDictTypes = GetDictObjByDictTypes

// 普通字典过滤器相关
import {
  GetLabelByCodeFilter,
  GetLabelByCodesFilter,
  GetCodeByLabelFilter,
  GetCodeByLabelsFilter
} from "~/filters/dict"
export const getLabelByCodeFilter = GetLabelByCodeFilter
export const getLabelByCodesFilter = GetLabelByCodesFilter
export const getCodeByLabelFilter = GetCodeByLabelFilter
export const getCodeByLabelsFilter = GetCodeByLabelsFilter

// 脱敏
import {Mask, MaskAddress, MaskIdCard, MaskName, MaskPhone, Desensitization} from "~/functions/mask"
export const mask = Mask
export const maskAddress = MaskAddress
export const maskIdCard = MaskIdCard
export const maskName = MaskName
export const maskPhone = MaskPhone
export const desensitization = Desensitization

// 日期格式化
import {FormatDate, IsDate} from "~/functions/date-format"
export const formatDate = FormatDate
export const isDate = IsDate

// 树形方法相关
import { ListToTree, GetTreeItemByCode, GetTreeItemByLabel } from "./functions/list-tree"
export const listToTree = ListToTree
export const getTreeItemByCode = GetTreeItemByCode
export const getTreeItemByLabel = GetTreeItemByLabel

// 树形字典方法相关
import {GetTreeLabelByCode, GetTreeCodeByLabel, GetTreeLabelByCodes, GetTreeCodeByLabels} from "./functions/tree-dict"
export const getTreeLabelByCode = GetTreeLabelByCode
export const getTreeCodeByLabel = GetTreeCodeByLabel
export const getTreeLabelByCodes = GetTreeLabelByCodes
export const getTreeCodeByLabels = GetTreeCodeByLabels

import {GetTreeLabelByCodeFilter, GetTreeCodeByLabelFilter, GetTreeLabelByCodesFilter, GetTreeCodeByLabelsFilter} from "./filters/tree-dict"
export const getTreeLabelByCodeFilter = GetTreeLabelByCodeFilter
export const getTreeCodeByLabelFilter = GetTreeCodeByLabelFilter
export const getTreeLabelByCodesFilter = GetTreeLabelByCodesFilter
export const getTreeCodeByLabelsFilter = GetTreeCodeByLabelsFilter

const filters = [
  {
    name: "getLabelByCodeFilter",
    func: GetLabelByCodeFilter
  },
  {
    name: "getLabelByCodesFilter",
    func: GetLabelByCodesFilter
  },
  {
    name: "getCodeByLabelFilter",
    func: GetCodeByLabelFilter
  },
  {
    name: "getCodeByLabelsFilter",
    func: GetCodeByLabelsFilter
  },
  {
    name: "getTreeLabelByCodeFilter",
    func: GetTreeLabelByCodeFilter
  },
  {
    name: "getTreeCodeByLabelFilter",
    func: GetTreeCodeByLabelFilter
  },
  {
    name: "getTreeLabelByCodesFilter",
    func: GetTreeLabelByCodesFilter
  },
  {
    name: "getTreeCodeByLabelsFilter",
    func: GetTreeCodeByLabelsFilter
  },
  {
    name: "formatDate",
    func: FormatDate
  },
  {
    name: "desensitization",
    func: Desensitization
  }
]

//获取字典数据
async function getDIctCodeReq(setting) {
  //从缓存中获取，如果没值 则从新获取
  const dictData = setting.storage.getItem(setting.dictDataKey)
  //添加判断，当是usuallyGetFileds 的时候 过滤掉缓存已经有的字典数据值  只请求没有的  当缓存中都有时 不请求
  const values = setting.usuallyGetFileds.split(",")
  const needGetArr = [] //保留需要请求的字典数组类型
  if (values.length > 0) {
    for (let i = 0; i < values.length; i++) {
      if (dictData[values[i]]) {
        continue
      }
      needGetArr.push(values[i])
    }
  }
 
  if (!dictData || setting.getDictEveryTime || needGetArr.length > 0) {
    let data
    let query
    if (setting.isGetAll) {
      query = ""
      store.mutations.SETTING_ISGETTING_ALL_DICT_TYPES(true) //设置正在请求所有字典为 true  禁止其他部门请求的 请求
      data = await setting.getDictCodeApi(setting.formatterRequest(setting.query))
      store.mutations.SETTING_ISGETTING_ALL_DICT_TYPES(false) //请求结束 设置正在请求所有字典为 false  禁止其他部门请求的 请求
    } else if (needGetArr.length > 0) {
      query = needGetArr.join(",")
      store.mutations.ADD_IS_EGTTING_DICT_TYPES(needGetArr.join(",")) //将这些字典类型列入到正在请求的字典数据当中
      data = await setting.getDictCodeApi(setting.formatterRequest(setting.query, query))
      store.mutations.REMOVE_IS_EGTTING_DICT_TYPES(needGetArr.join(",")) //将这些字典类型从正在请求的字典数据当中移除
    }
    //格式化数据
    const dictCodeList = setting.formatterDictList(data, query)
    const version = setting.formatterDictVersion(data)
    setting.storage.setItem(setting.versionKey, version) //设置字典版本号

    //把本地字典数据也存起来
    const dictObjs = Object.assign(JSON.parse(JSON.stringify(setting.localDictCodes)), dictCodeList)
    store.mutations.SET_DICT_CODES(dictObjs)
    setting.storage.setItem(setting.dictDataKey, JSON.stringify(dictObjs)) //设置字典数据
    
  }
}

const vue2ElementDict = {
  async install(Vue, config) {
    /**
     * @description: 字典包
     * @param {*} Vue
     * @param {*} config :{
     *    axiosSetting,  请求设置  axios   requestName
     *    getDictCodeApi,  获取字典数据接口  必传
     *    version, 版本号  首次加载传入字典数据最新的版本号，匹配当前版本号是否一致，不一致时清空缓存数据，并存入最新版本号  必传
     *    query,  请求字典接口参数名 默认 type
     *    usuallyGetFileds, 常用字典数据  默认空  字符串 逗号隔开
     *    versionKey, 版本号缓存键名
     *    dictDataKey, 字典数据缓存键名
     *    format, 定义字段名
     *    formatterDictList,  格式化字典数据
     *    formatterDictVersion, 格式化字典数据版本
     *    formatterRequest, 格式化请求数据格式
     *    storage,  存储位置  localstorage   sessionstorage
     *    isGetAll,  请求全部
     *    treeSetting, 数组转树形数据配置
     *    localDictCodes, 本地缓存数据
     *    getDictEveryTime  是否每次都请求
     *    filterDataFun 组件过滤数据方法函数 默认不变
     *    disabledDataFun 组件禁用数据方法函数 默认不变
     * }
     * @return {*}
     * @author: syx
     */
    const defaultConfig = {
      //组件过滤数据 配置
      filterDataFun: (list) => {
        return list
      },
      //组件禁用数据 配置
      disabledDataFun: (list) => {
        return list
      },
      //配置数组数据转化成树形数据
      treeSetting: {
        idField: "id", //唯一标识字段名
        parentIdField: "parentId", //父节点唯一标识字段名
        childrenField: "children", //子节点标识字段名
        firstId: "0", // 根节点值
        labelField: "label", //label字段名
        labelArrField: "labelArr", //给对象新增的中文数组字段名
        idArrField: "idArr", //给对象新增的id数组字段名
        levelField: "level", //给对象新增的层级字段名
        level: 0, // 给第一级展示的层级
        leafField: "leaf" //叶子节点标识字段名
      },
      query: "dictType",
      versionKey: "vue2ElementDictVersion",
      dictDataKey: "vue2ElementDictData",
      format: {
        value: "value",
        label: "label"
      },
      formatterRequest: (query, dictType) => {
        if (!dictType) {
          return { [query]: "" }
        }
        return { [query]: dictType }
      },
      formatterDictList: (
        data,
        query
      ) => {
        return data?.dictData
      },
      formatterDictVersion: (data) => {
        return data.version
      },
      storage: localStorage,
      usuallyGetFileds: "",
      isGetAll: false,
      localDictCodes: {}, //本地数据
      getDictEveryTime: false
    }
    config.treeSetting = Object.assign(defaultConfig.treeSetting, config.treeSetting)
    const setting = Object.assign(defaultConfig, config)

    store.mutations.SET_DICT_SETTING(setting)
    const dictList = JSON.parse(setting.storage.getItem(setting.dictDataKey)) || {}
    //把本地字典数据也存起来
    let dictObjs = JSON.parse(JSON.stringify(setting.localDictCodes))
    dictObjs = Object.assign(dictList, dictObjs)
    setting.storage.setItem(setting.dictDataKey, JSON.stringify(dictObjs))
    store.mutations.SET_DICT_CODES(dictObjs)

    //如果缓存的数据非最新数据，清除缓存
    const currentversion = setting.storage.getItem(setting.versionKey) //当前字典数据的版本号
    if (setting.version !== currentversion) {
      setting.storage.removeItem(setting.dictDataKey) //清除缓存数据
      setting.storage.setItem(setting.versionKey, setting.version) //设置字典版本号

      setting.storage.setItem(setting.dictDataKey, JSON.stringify(setting.localDictCodes))
      //版本号不一样，把字典数据设置为 本地字典数据
      store.mutations.SET_DICT_CODES(setting.localDictCodes)
    }
    if (setting.isGetAll || setting.usuallyGetFileds) {
    //获取字典数据，是否一次性全部 还是 获取 部分
      getDIctCodeReq(setting)
    }

    // 遍历注册全局组件
    components.map(component => Vue.component(component.name, component))

    // 注册过滤器
    filters.map(filter => {
      Vue.filter(filter.name, filter.func)
    })
  }
}

export default vue2ElementDict